import QrCodeIcon from './QrCodeIcon';
import './QrCodeIcon.scss';

export default QrCodeIcon;
